const CONSENT_STORAGE_KEY = "analytics-consent";

declare global {
  interface Window {
    dataLayer?: Array<unknown>;
    gtag?: (...args: any[]) => void;
    __gtagConsentBootstrapped__?: boolean;
  }
}

(() => {
  if (typeof window === "undefined") return;
  if (window.__gtagConsentBootstrapped__) return;
  window.__gtagConsentBootstrapped__ = true;

  // Ensure dataLayer and gtag stubs exist before the real library loads.
  if (!Array.isArray(window.dataLayer)) {
    window.dataLayer = [];
  }
  if (typeof window.gtag !== "function") {
    window.gtag = function gtagStub(...args: any[]) {
      window.dataLayer!.push(args);
    };
  }

  let stored: string | null = null;
  try {
    stored = window.localStorage.getItem(CONSENT_STORAGE_KEY);
  } catch {
    stored = null;
  }

  const granted = stored === "granted";
  window.gtag("consent", "default", {
    analytics_storage: granted ? "granted" : "denied",
  });
})();

export {};
